import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncCreateOrganizationModuleType = createAsyncThunk(
  "/fetchAsyncCreateOrganizationModuleType",
  async (data) => {
    try {
      const response = await axiosInstance.post('/org-module/create', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncUpdateOrganizationModuleType = createAsyncThunk(
  "/fetchAsyncUpdateOrganizationModuleType",
  async (data) => {
    try {
      const response = await axiosInstance.post(`/org-module/update/${data?.id}`, data?.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetOrganizationModuleType = createAsyncThunk(
    "/fetchAsyncGetOrganizationModuleType",
    async () => {
      try {
        let url = `${API_URL}/org-module/get`;
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  export const fetchAsyncDeleteModuleType = createAsyncThunk(
    "/fetchAsyncDeleteModuleType",
    async (id) => {
      try {
        let url = `${API_URL}/org-module/delete/${id}`;
        const response = await axiosInstance.delete(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
  );

  const AllOrganizationModuleTypeSlice = createSlice({
    name: "moduleType",
    initialState,
    reducers: {},
    extraReducers: {
      [fetchAsyncGetOrganizationModuleType.pending]: (state) => {},
      [fetchAsyncGetOrganizationModuleType.fulfilled]: (state, { payload }) => {
        return payload;
      },
    },
  });

 
  export const getAllModuleType = (state) => state.moduleType;

export default AllOrganizationModuleTypeSlice.reducer;

  



